import type { ReferralAPI } from '../reducer.ts'

export type SanitizedReferralPartition = {
  populatedFields: Partial<ReferralAPI>
  fieldsClearedToNull: Partial<ReferralAPI>
}

export const partitionSanitizedReferralForMerge = (
  sanitizedPayload: Partial<ReferralAPI>
): SanitizedReferralPartition => {
  const populatedFields: Record<string, unknown> = {}
  const fieldsClearedToNull: Record<string, null> = {}

  for (const [key, value] of Object.entries(sanitizedPayload)) {
    if (value !== undefined && value !== '') {
      populatedFields[key] = value
      continue
    }
    if (value === '') {
      fieldsClearedToNull[key] = null
    }
  }

  return {
    populatedFields: populatedFields as Partial<ReferralAPI>,
    fieldsClearedToNull: fieldsClearedToNull as Partial<ReferralAPI>,
  }
}
